import { render, staticRenderFns } from "./PredictedTransaction.vue?vue&type=template&id=0a11682c&scoped=true&"
import script from "./PredictedTransaction.vue?vue&type=script&lang=js&"
export * from "./PredictedTransaction.vue?vue&type=script&lang=js&"
import style0 from "./PredictedTransaction.vue?vue&type=style&index=0&id=0a11682c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a11682c",
  null
  
)

export default component.exports